import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import Cookie from "js-cookie";
import Store from "./store";

Vue.use(VueRouter);

//解决Vue中重复点击相同路由控制台报错问题
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

//读取地址栏参数
function getQuery(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

const router = new VueRouter({
  routes: [
    //问答页
    {
      path: "/forum",
      meta: {
        title: "香港七星堂2021年12生肖运程"
      },
      children: [
        {
          path: "",
          meta: {
            title: "在线问师傅"
          },
          component: () => import("@/components/ask-lists")
        },
        {
          path: "/forum/view",
          meta: {
            title: "查看问题"
          },
          component: () => import("@/components/ask-view")
        }
      ],
      component: () => import("@/views/forum")
    },
    //首页（放最后）
    {
      path: "*",
      name: "sx",
      component: () => import("@/views/index"),
      meta: {
        title: "香港七星堂2021年12生肖运程"
      }
    }
  ]
});

router.beforeEach(async (to, froms, next) => {
  NProgress.start();
  //参数
  let toQuery = to.query;
  let fmQuery = froms.query;
  let { sxi, sex, sxy, sellid, from } = toQuery;
  //let { sellid, from } = foQuery;

  if (sellid) {
    Cookie.set("sellid", sellid);
  } else if (fmQuery.sellid) {
    sellid = fmQuery.sellid;
  } else if (getQuery("sellid")) {
    sellid = getQuery("sellid");
  } else if (Cookie.get("sellid")) {
    sellid = Cookie.get("sellid");
  }
  if (from) {
    Cookie.set("from-" + sellid, from);
  } else if (fmQuery.from) {
    from = fmQuery.from;
  } else {
    from = Cookie.get("from-" + sellid);
  }
  Store.commit("setSxi", sxi);
  Store.commit("setSex", sex);
  Store.commit("setSxy", sxy);
  Store.commit("setSellid", sellid);
  Store.commit("setFrom", from);
  // 有Sellid时跳转
  if ((!toQuery.sellid && sellid) || (!toQuery.from && from)) {
    if (sellid) {
      toQuery.sellid = sellid;
    }
    if (from) {
      toQuery.from = from;
    }

    console.log("toQuery", toQuery);
    return next({
      path: to.path,
      query: toQuery
    });
  }
  let title = to.meta.title;
  if (title) {
    document.title = title;
  }

  next();
});
router.afterEach(() => {
  // finish progress bar
  NProgress.done();
  // 返回顶部
  window.scrollTo(0, 0);

  // 添加统计
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function() {
      //每次执行前，先移除上次插入的代码
      document.getElementById("baidu_tj") &&
        document.getElementById("baidu_tj").remove();
      var hm = document.createElement("script");
      hm.src = "https://w.cnzz.com/c.php?id=1260874826";
      hm.id = "baidu_tj";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 500);
});

export default router;
